var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-redirect-form',{ref:"form",attrs:{"source":_vm.source,"occup-id":_vm.occupId,"token":_vm.token,"username":_vm.username}})
}
var staticRenderFns = []

export { render, staticRenderFns }